import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    NSAIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={NSAIconImg} preview={false}/>
